module.exports = "/assets/data/86ae639b3097d7e630b9de4302a62234-G51.data.json";